module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/7f438aec870c01467e9516933d1af3ec.png";